export enum FilterPrimaryUseClassEnum {
  primary = 'primary',
  either = 'either',
  secondary = 'secondary',
}

export enum CompanySpatialSearchRecordTypeEnum {
  company = 'company',
  property = 'property',
}

export enum OccupierSpatialSearchRecordTypeEnum {
  occupier = 'occupier',
  company = 'company',
}
